import React, { useMemo } from "react";
import PipelineColumn from "./PipelineColumn";

/**
 * @param {Object} props
 * @param {{ id: string, label: string, dotClass: string }[]} props.stages
 * @param {import('../hooks/usePipelineBoard').PipelineCardModel[]} props.cards
 * @param {(cardId: string) => void} props.onAdvanceCard
 * @param {(cardId: string) => void} [props.onPrimaryAction]
 * @param {(cardId: string) => void} [props.onMore]
 * @param {(cardId: string) => void} [props.onOpenCard]
 * @param {() => void} [props.onAddInfluencer]
 */
function PipelineBoard({
  stages,
  cards,
  onAdvanceCard,
  onPrimaryAction,
  onMore,
  onOpenCard,
  onAddInfluencer,
}) {
  const byStage = useMemo(() => {
    /** @type {Record<string, import('../hooks/usePipelineBoard').PipelineCardModel[]>} */
    const map = {};
    stages.forEach((s) => {
      map[s.id] = [];
    });
    cards.forEach((c) => {
      if (map[c.stageId]) map[c.stageId].push(c);
    });
    return map;
  }, [cards, stages]);

  return (
    <div className="overflow-auto h-[calc(100vh-220px)] pb-4 -mx-1 px-1 bg-[#FFF]">
      <div className="flex gap-3 min-w-max">
        {stages.map((stage) => (
          <PipelineColumn
            key={stage.id}
            stage={stage}
            cards={byStage[stage.id] ?? []}
            onAdvanceCard={onAdvanceCard}
            onPrimaryAction={onPrimaryAction}
            onMore={onMore}
            onOpenCard={onOpenCard}
            onAddInfluencer={onAddInfluencer}
          />
        ))}
      </div>
    </div>
  );
}

export default PipelineBoard;
